import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  // uri: "http://localhost/graphql",
  uri: "https://next.lacuredata.com/graphql",
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      // Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI2IiwianRpIjoiZmNiNmQxNmIyMWU4MjliZDc1MjVjOGMzNDJjYWZkZjJmNzJlNjRiOWI0MmZkZDA2ZDAzMzBhMWI2M2QwMjZkNGFkYjhjZmZkZmI3MGI4MGQiLCJpYXQiOjE2NDQyNDczMDYuOTk0MzQ2LCJuYmYiOjE2NDQyNDczMDYuOTk0MzQ4LCJleHAiOjE2NzU3ODMzMDYuOTg0MTEsInN1YiI6IjEiLCJzY29wZXMiOltdfQ.n9mMK0SQJZDGotOotGBy630XmEe7la4msMciWJ0i7HXHrpptm2MeHfvc2e-5MJHbpwugnvhdCCqdmg0ImkzZC3uZQbTT6dc6eoC0IZT4zO4F7M-Fy1s3Qq_V5p7PboXj_eAS2xdPK7ZKKBSGiLUB1WxyZH31xwZMFTpPZ3gCK1mEdy-uk7B0vIwT30RAYqE6FSP0ECIB9rEYz-E6aEdnb9yA4Qkw7RSbRj1Pi5qQLRK4rNy7H-iAqVw-rSTXtCT7vYghWARK3RMZI-PO-HMUR-YMKr9B-HVqZNkBUliDU2UANeLNv99r7sBBBAoP32yoPtCDZh8xSx2V6IBdXa0lC4FLLDV6PCnx8I9a6BqckgmIdUsFNt27c0q8B6qhrpuMRL1Px9lg7oOAcnk-PzrgHYlu5QqIQA9wmGa8AhPGmHVIZCtPfxPrjoewcgZbFPZrVyiwQOIFvEddb3cFqH_mzIyE5g5IbYbSCT1EJN5OssGMdrUEy2y75-ez-a2dFrmada1GWpj1JWMppwlDYoCsjo8ekL4riGIIVpuO8qdv6dflJipCAoo0Y_m6kO8Gm-f2EE0h67mcpCYKK2Tw34QmryBhNqETb3wht8XFTJjWm0RbyEsGDLMjr9TJvPNP7BICK-j9rVVcwUpHCA12aWLSots_J-6Kz_su25XLEfj4u1U`,
      Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNWU3NDNkMzcwNzUwY2IzZmQyY2UzODRmZWYwNWE0Y2Y2NDIyODljMDQxYzk4MWJhNzIwMWU4N2ZjOWMzZjIxYzc5NjQwMWMxZjU5NTc0ZTkiLCJpYXQiOjE3NjExNTI4NDcuNDU2MzMsIm5iZiI6MTc2MTE1Mjg0Ny40NTYzMzIsImV4cCI6MTg1NTg0NzI0Ny40NDQxOTYsInN1YiI6IjEiLCJzY29wZXMiOltdfQ.Aldjr_lswBhrpKs4NlQz3OxOE-wIAtdo1m0ANZS39m0_-oll7WUDl2AWlivzW8npAnjMbn4TSINjgLXAFDbciueV_4LhpRAWTf24m6PG-8NL_YD9VVvmSvih5hB_1NwXLN15H7f5ARaZ_H4Ia4P5uXQmodabvpveaLjVNVKn_bdraffZYP2rkoZai7VHnYsk6mGbKs5lOM4QggkljA7nGJa82jtMmlNTS14hvKy3YyVldR_N5ca4l-PTjCkdj2QBhp3ObsZTHQUOsLOu12iEu1WbvDokMj3I64UQBrY2K84eZWfbYsHSx1z4LZJ6dJof-NVhvIL9vbg5nAfJVzcgYIxv8D324ed9MLWsXSqQrMq0V2oBx6gBp-Jp5V3pmNfETV8UBY8zNU9sSacFo1zdJrwZu4xGbX2CHGNCsw3usbzTC6USiKBuEs1dMR419y0bjVpPqBqQhxq7nWKLe_2M97LOaPkSiKsFZLqpa5yxCHCMe8lFHyhfGr9t6PlLrGbFib5vsRQhP4erV3FEAwmd198a9gYXV-Sbw03i_O9gCFIzLgPMEVAUEPhYr-Sjj4GJJJNRBlIMw2M4ZiDhobn4sThJVUDBHlt4KfTGKog_rg4URxLSWEo407duUW6LGOWrzzTjdPSgUtPw0-2Dt6q2FO0K03u6Hh8OTwax5GJxeIY`,
    },
  };
});

// Cache implementation
const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        activityLogs: {
          read(existing) {
            return existing;
          },
          merge(existing, incoming) {
            let logs = Object.assign([], existing ? existing.data : []);

            incoming.data.forEach((villa, index) => {
              logs[index + incoming.paginatorInfo.firstItem - 1] = villa;
            });

            return {
              ...incoming,
              data: logs,
            };
          },
        },
        villas: {
          keyArgs: [
            "search",
            "country",
            "vendor",
            "calendar",
            "calendarStatus",
          ],
          read(existing, { args: { first, page } }) {
            return (
              existing && {
                ...existing,
                data: existing.data.slice(
                  first * (page - 1),
                  first * (page - 1) + first
                ),
              }
            );
          },
          merge(existing, incoming) {
            let items = Object.assign([], existing ? existing.data : []);

            incoming.data.forEach((item, index) => {
              items[index + incoming.paginatorInfo.firstItem - 1] = item;
            });

            return {
              ...incoming,
              data: items,
            };
          },
        },
      },
    },
  },
});

// Create the apollo client
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});

export default apolloClient;
